<template lang="pug">
  .slide.has-background-white
    .is-size-5 Презентация
    div.m-t-15 {{model.title}}
    img.is-block.m-t-15(:src="model.thumbnail" :alt="model.title")
</template>

<script>
export default {
  name: 'presentation-info',

  props: {
    model: Object,
  },
};
</script>
